export default __webpack_public_path__ + "d036680f5d255b4d2eee11961e12fdf9.svg";